import styled from "styled-components";
// 지점 선택 버튼. 화면 글자(번역될 수 있음) 대신 location 값으로 선택한다
const BranchElement = ({ location, setLocation, selectedBranch }) => {
  return (
    <Button
      type="button"
      aria-pressed={selectedBranch === location}
      onClick={() => setLocation(location)}
    >
      {location}
    </Button>
  );
};
export default BranchElement;
const Button = styled.button`
  cursor: pointer;
  border: 0;
  border-radius: 0.75rem;
  padding: 0.75rem 1.1rem;
  background: transparent;
  text-align: left;
  font-size: 1.05rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.monotone.dark};
  transition: background-color 0.15s, color 0.15s;
  &:hover {
    background-color: ${({ theme }) => theme.colors.monotone.extralight};
    color: ${({ theme }) => theme.colors.accent};
  }
  &[aria-pressed="true"] {
    background-color: ${({ theme }) => theme.colors.dark};
    color: white;
  }
  @media (max-width: 767px) {
    text-align: center;
    padding: 0.55rem 0.9rem;
    font-size: 0.95rem;
  }
`;
